import type { CareTeamMember } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getCareTeam(
  patientId: string,
  searchParams: Record<string, string> = { show_history: "true" },
): Promise<CareTeamMember[]> {
  return sharedRequestsTyped.fetch_patient_careteam({
    context: { showLoader: false },
    searchParams,
    urlParams: { patientId },
  });
}
